import BlockEngineAnalytics from '@/BlockEngineAnalytics/BlockEngineAnalytics';
import BlockEngineComparer from '@/BlockEngineComparer/BlockEngineComparer';
import AuthCallback from '@/components/auth/AuthCallback';
import BlockEngineBuilder from '@/components/BlockEngineBuilder';
import Home from '@/Home/Home';
import { createBrowserRouter } from 'react-router-dom';
import ErrorPage from './ErrorPage';
import NotFound from './NotFound';
import ProtectedRoute from './ProtectedRoute';

const router = [
  {
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/',
        element: <Home />
      },
      {
        path: 'builder',
        element: (
          <ProtectedRoute>
            <BlockEngineBuilder />
          </ProtectedRoute>
        )
      },
      {
        path: 'analytics',
        element: (
          <ProtectedRoute>
            <BlockEngineAnalytics />
          </ProtectedRoute>
        )
      },
      {
        path: 'comparer',
        element: (
          <ProtectedRoute>
            <BlockEngineComparer />
          </ProtectedRoute>
        )
      },
      {
        path: 'openid/callback',
        element: <AuthCallback />
      },
      { path: '*', element: <NotFound /> }
    ]
  }
];

const Router = () => {
  const routing = createBrowserRouter(router);
  return routing;
};

export default Router;
